jQuery(document).ready(function () {
    const mailTester = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    grecaptcha.ready(function () {
        grecaptcha.execute('6LcJKqYUAAAAAHpJiOxyKQ1GJwhiYgmoP3TlqfL8', { action: 'homepage' }).then(function (token) {
            //console.log(token);
            $("#g-recaptcha-response").val(token);
        });
    });

    $('#contactForm').on('submit', function(e) {
        var name = $("#name");
        var email = $("#email");
        var message = $("#message");
        var sendButton = $('#send');
        var sendButtonText = $('#send').text();

        var formData = new FormData(this);
        
        disableInputs(name, email, message, sendButton, true);


        if (isFormValid(name, email, message)) {
            $('#error').hide();
            $('#send').html('<i class="fas fa-spinner fa-spin"></i>');
            $('#send').css('width', 'auto');
            $("#errorRequired").hide();

            $.ajax({
                url: this.action,
                method: 'POST',
                type: 'POST',
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                success: function (result) {
                    if (result.error) {
                        $("#errorServer").html('Server error');
                        $("#errorServer").show();
                        $('#send').html(sendButtonText);
                        $('#send').css('width', '100%');
                        }
                    else if (result.invalid) {
                        $("#errorServer").html('Invalid captcha');
                        $("#errorServer").show();
                        $('#send').html(sendButtonText);
                        $('#send').css('width', '100%');
                        }
                    else {
                        $("#errorServer").hide();
                        $("#name").val('');
                        $("#email").val('');
                        $("#message").val('');
                        $('#send').css('background-color', '#20c345');
                        $('#send').html('<i class="fas fa-check"></i>');
                        window.setTimeout(function () {
                            $('#send').css('background-color', '#47c9e5');
                            $('#send').html(sendButtonText);
                            $('#send').css('width', '100%');
                        }, 1000);
                    }
                },

                error: function (result) {
                    $("#errorServer").html('Server error (' + result.status.toString() +')');
                    $("#errorServer").show();
                    $('#send').html(sendButtonText);
                    $('#send').css('width', '100%');
                }
            });
        }
        else {
            $("#errorRequired").show();
        }
        disableInputs(name, email, message, sendButton, false);
        e.preventDefault();
    });

    function disableInputs(name, email, message, sendButton, condition) {
        name.prop("disabled", condition);
        email.prop("disabled", condition);
        message.prop("disabled", condition);
        sendButton.prop("disabled", condition);
    }

    function isFormValid(name, email, message) {

        let isFormValid = true;
        //Name
        if (name.val() === "") {
            name.addClass("required");
            isFormValid = false;
        } else {
            name.removeClass("required");
        }
        //Email
        if (!mailTester.test(email.val())) {
            email.addClass("required");
            isFormValid = false;
        } else {
            email.removeClass("required");
        }
        //Message
        if (message.val() === "") {
            message.addClass("required");
            isFormValid = false;
        } else {
            message.removeClass("required");
        }

        return isFormValid;
    }
});
